import { useLocation } from 'react-router-dom';
import { hot } from 'react-hot-loader/root';
import { AppContainer, useRentalManagerUser } from '@zg-rentals/rental-manager-env';
import { useSiftScience } from '@zg-rentals/sift-science';
import { ToastProvider } from '@zillow/constellation-10';
import { Provider } from 'react-redux';
import { getRoutes } from '../app/routes';
import store from '../redux/store';
import { UserManagementStateProvider } from '../providers/UserManagementStateProvider';
import { DefaultQueryProvider } from '@zg-rentals/react-query5';
import { useRegisterNotification } from '@zg-rentals/register-notification';
import { useComscorePageTracking } from '@zg-rentals/comscore';
import { trackComscoreEvent, trackUserEvent } from '../analytics';
import React from 'react';
import '../index.css';
import { useZrmPageViewEvents } from '@zg-rentals/clickstream';

const App = () => {
  const { user } = useRentalManagerUser();
  const location = useLocation();

  useComscorePageTracking(() => trackComscoreEvent({}), location.pathname);
  useSiftScience({ email: user?.email, isImpersonator: Boolean(user?.impersonatorUserToken) });
  useRegisterNotification({ ref: 'USER_MANAGEMENT_WEB' });
  useZrmPageViewEvents(trackUserEvent, location.pathname, user);

  React.useLayoutEffect(() => {
    document.body.setAttribute('data-panda-theme', 'zillow');

    return () => {
      document.body.removeAttribute('data-panda-theme');
    };
  }, []);

  return (
    <DefaultQueryProvider>
      <UserManagementStateProvider>
        <Provider store={store}>
          <ToastProvider>
            <AppContainer forceAltLogo>{getRoutes()}</AppContainer>
          </ToastProvider>
        </Provider>
      </UserManagementStateProvider>
    </DefaultQueryProvider>
  );
};

export default hot(App);
